import axios from 'axios';
import { loginActions } from './loginActions.js';

const SESSION_EXPIRED = "SESSION_EXPIRED";
const SESSION_EXPIRED_DISMISS = "SESSION_EXPIRED_DISMISS";

const sessionExpired = () => {
    return {
        type: SESSION_EXPIRED
    };
};

const sessionExpiredDismiss = () => {
    return {
        type: SESSION_EXPIRED_DISMISS
    };
};

// 401s from these endpoints mean bad credentials, which the forms already report.
const AUTH_ENDPOINT_PATHS = ['/auth/login', '/auth/signup', '/auth/reset/mnbv'];

const setupSessionExpiryInterceptor = (store) => {
    axios.interceptors.response.use(
        response => response,
        error => {
            const isUnauthorized = error.response?.status === 401;
            const url = error.config?.url || '';
            const hadToken = localStorage.getItem('token') !== null;
            const isAuthEndpoint = AUTH_ENDPOINT_PATHS.some(path => url.includes(path));

            if (isUnauthorized && hadToken && !isAuthEndpoint) {
                localStorage.removeItem('token');
                store.dispatch({ type: loginActions.AUTH_ERR });
                store.dispatch(sessionExpired());
            }
            return Promise.reject(error);
        }
    );
};

export const sessionActions = {
    SESSION_EXPIRED,
    SESSION_EXPIRED_DISMISS,
    sessionExpired,
    sessionExpiredDismiss,
    setupSessionExpiryInterceptor
};
